import { LOCAL, PROD, PROTO0, STAGING } from './env'
import localConfig from './env/local'
import proto0Config from './env/proto0'
import stagingConfig from './env/staging'
import prodConfig from './env/prod'
import baseConfig from './env/base'
import { crToLocale, localeToCr, localeToBraze } from './langMap'

const configMap = {
  [LOCAL]: localConfig,
  [PROTO0]: proto0Config,
  [STAGING]: stagingConfig,
  [PROD]: prodConfig,
}

const getEnv = () => {
  let ENV = PROD

  if (typeof window !== 'undefined') {
    if (window.location.href.indexOf('localhost') > -1) {
      ENV = LOCAL
    } else if (window.location.href.indexOf('cr.etp-proto0.com') > -1) {
      ENV = PROTO0
    } else if (window.location.href.indexOf('dev.crunchyroll.com') > -1) {
      ENV = PROTO0
    } else if (window.location.href.indexOf('stage.crunchyroll.com') > -1) {
      ENV = STAGING
    } else if (window.location.href.indexOf('stg.animefutureforum.com') > -1) {
      ENV = STAGING
    } else if (window.location.href.indexOf('crunchyroll.com') > -1) {
      ENV = PROD
    }
  }

  if (process.env.NODE_ENV === 'development') {
    ENV = STAGING
  }

  return ENV
}

export default {
  ...baseConfig,
  ...configMap[getEnv()],
  segment: {
    ...baseConfig.segment,
    ...configMap[getEnv()].segment,
  },
  segmentGen2: {
    ...baseConfig.segmentGen2,
    ...configMap[getEnv()].segmentGen2,
  },
  storyblok: {
    ...baseConfig.storyblok,
    ...configMap[getEnv()].storyblok,
  },
  endpoints: {
    ...baseConfig.endpoints,
    ...configMap[getEnv()].endpoints,
  },
  localeMap: {
    crToLocale,
    localeToCr,
    localeToBraze,
  },
}
